/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import CustomButtons from '../../../../../components/Button/CustomButtons';

import './Preview.css';

const commonMessages = {
  agentIs: 'When agent is',
  agentIsNot: 'When agent is not',
  duringContainer: 'During container',
  notDuringContainer: 'Not during container',
  duringSegment: 'During segment',
  notDuringSegment: 'Not during segment',
  notApplicable: 'Not Applicable',
  empty: '(empty)'
};
const ALERT_TYPE = {
  reminder: 'Reminder',
  performance: 'Performance',
  schedule: 'Schedule'
};

const Preview = ({
  customPreview, dimensionPreview, taggingPreview, handleBack, handleSubmit, loading, alertType, ruleType
}) => {

  // eslint-disable-next-line consistent-return
  const handleBackPage = (status) => {
    if (status === 'Cancel') {
      return handleBack(status);
    }
    handleBack();
  };

  const DimensionSchedulePreview = (dataPreview, message) => dataPreview.map(data => (
    <div key={1} className='preview__row'>
      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>Rule Name </p>}
        <p className='preview__wrapper__title'>Alarm Type </p>
        <p className='preview__wrapper__title'>
          {data.agentStatus ? message.agentIs : message.agentIsNot}
        </p>
        <p className='preview__wrapper__title'>
          {data.containerStatus ? message.duringContainer : message.notDuringContainer}
        </p>
        <p className='preview__wrapper__title'>
          {data.segmentStatus ? message.duringSegment : message.notDuringSegment}
        </p>
      </div>
      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>{data.ruleName}</p>}
        <p className='preview__wrapper__title'>{data.scheduleAlarmCode}</p>
        <p className='preview__wrapper__title'>{data.ACDOption === '' ? message.notApplicable : data.ACDOption}</p>
        <p className='preview__wrapper__title'>{data.container && data.container !== '' ? data.container : message.notApplicable}</p>
        <p className='preview__wrapper__title'>{data.segment && data.segment !== '' ? data.segment : message.notApplicable}</p>
      </div>
    </div>
  ));
  const DimensionPerformancePreview = (dataPreview, message) => dataPreview.map(data => (
    <div key={1} className='preview__row'>
      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>Rule Name </p>}
        <p className='preview__wrapper__title'>ACD Status </p>
        <p className='preview__wrapper__title'>Minimum Threshold (in minutes)</p>
        <p className='preview__wrapper__title'>Maximum Threshold (in minutes)</p>
        <p className='preview__wrapper__title'>Flag Frequency (in minutes)</p>

        <p className={data.agent_status === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>User to be notified </p>
        <p className={data.agent_status === 1 ? 'preview__wrapper__title large' : 'preview__wrapper__title disabled'}>Notification text </p>
        <p className={data.GA_status === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>User to be notified </p>
        <p className={data.GA_status === 1 ? 'preview__wrapper__title large' : 'preview__wrapper__title disabled'}>Notification text </p>
        <p className='preview__wrapper__title large'>Zoom Channel </p>
      </div>

      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>{data.ruleName}</p>}
        <p className='preview__wrapper__title'>{data.ACDOption}</p>
        <p className='preview__wrapper__title'>{data.minimum}</p>
        <p className='preview__wrapper__title'>{data.maximum}</p>
        <p className='preview__wrapper__title'>{data.flagFrequency}</p>

        <p className={data.agent_status === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>Agent</p>
        <p className={data.agent_Notification ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title disabled'}>{data.agent_Notification ?? message.empty}</p>
        <p className={data.GA_status === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>G&A</p>
        <p className={data.GA_Notification ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title disabled'}>{data.GA_Notification ?? message.empty}</p>
        <p className='preview__wrapper__title'>{data.Channel ? data.Channel.Name : commonMessages.empty}</p>
      </div>
    </div>
  ));
  const DimensionAdherencePreview = (dataPreview, message) => dataPreview.map(data => (
    <div key={1} className='preview__row'>
      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>Rule Name </p>}
        <p className='preview__wrapper__title'>Segment </p>
        <p className='preview__wrapper__title'>Reminder (in minutes) </p>
        <p className='preview__wrapper__title large'>Agent Notification Text </p>
        <p className='preview__wrapper__title large'>Zoom Channel </p>
      </div>
      <div className='preview__wrapper'>
        {!ruleType && <p className='preview__wrapper__title'>{data.ruleName}</p>}
        <p className='preview__wrapper__title'>{data.segment}</p>
        <p className='preview__wrapper__title'>{data.reminder}</p>
        <p className={data.agent_Notification ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title disabled'}>{data.agent_Notification ?? message.empty}</p>
        <p className='preview__wrapper__title'>{data.Channel ? data.Channel.Name : commonMessages.empty}</p>
      </div>
    </div>
  ));

  return (
    <>
      <div className='preview__container'>
        {ruleType && customPreview.map((t) => (
          <div key={1} className='preview__row'>
            <div className='preview__wrapper'>
              <p className='preview__wrapper__title'>Rule Name </p>
              <p className='preview__wrapper__title'>Client </p>
              <p className='preview__wrapper__title'>Program </p>
              <p className='preview__wrapper__title'>Project </p>
              <p className='preview__wrapper__title'>Site </p>
            </div>
            <div className='preview__wrapper'>
              <p className='preview__wrapper__title'>{t.ruleName}</p>
              <p className='preview__wrapper__title'>{t.clients}</p>
              <p className='preview__wrapper__title'>{t.programs}</p>
              <p className='preview__wrapper__title'>{t.projects}</p>
              <p className='preview__wrapper__title'>{t.sites}</p>
            </div>
          </div>
        ))}

        {alertType === ALERT_TYPE.schedule && DimensionSchedulePreview(dimensionPreview, commonMessages)}
        {alertType === ALERT_TYPE.performance && DimensionPerformancePreview(dimensionPreview, commonMessages)}
        {alertType === ALERT_TYPE.reminder && DimensionAdherencePreview(dimensionPreview, commonMessages)}

        {alertType === ALERT_TYPE.schedule && taggingPreview.map((t) => (
          <div key={1} className='preview__row'>
            <div className='preview__wrapper'>
              <p className='preview__wrapper__title'>Tag </p>
              <p className='preview__wrapper__title'>{t.scheduleAlarmCode === 'WOX' ? 'Actions' : 'Tag Duration'}</p>
              {t.scheduleAlarmCode === 'SIU' ? <p className='preview__wrapper__title'>Tagging Window</p> : null}
              <p className='preview__wrapper__title'>Minimum Threshold (in minutes)</p>
              <p className='preview__wrapper__title'>Maximum Threshold (in minutes)</p>
              <p className='preview__wrapper__title'>Flag Frequency (in minutes)</p>
              <p className={t.notes ? 'preview__wrapper__title large' : 'preview__wrapper__title'}>Notes </p>
              <p className={t.notifyAgent === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>User to be notified </p>
              <p className={t.notifyAgent === 1 ? 'preview__wrapper__title large' : 'preview__wrapper__title disabled'}>Notification text </p>
              <p className={t.notifyGA === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>User to be notified </p>
              <p className={t.notifyGA === 1 ? 'preview__wrapper__title large' : 'preview__wrapper__title disabled'}>Notification text </p>
              <p className='preview__wrapper__title large'>Zoom Channel </p>
            </div>
            <div className='preview__wrapper'>
              <p className='preview__wrapper__title'>{t.tag ?? commonMessages.notApplicable}</p>
              <p className='preview__wrapper__title'>{t.tagDuration}</p>
              {t.scheduleAlarmCode === 'SIU' ? <p className='preview__wrapper__title'>{t.taggingWindow ? t.taggingWindow : commonMessages.notApplicable}</p> : null}
              <p className='preview__wrapper__title'>{t.minimum}</p>
              <p className='preview__wrapper__title'>{t.maximum}</p>
              <p className='preview__wrapper__title'>{t.flagFrequency ?? commonMessages.notApplicable}</p>
              <p className={t.notes ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title'}>{t.notes ?? commonMessages.empty}</p>
              <p className={t.notifyAgent === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>Agent</p>
              <p className={t.agentNotification ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title disabled'}>{t.agentNotification ?? commonMessages.empty}</p>
              <p className={t.notifyGA === 1 ? 'preview__wrapper__title' : 'preview__wrapper__title disabled'}>G&A</p>
              <p className={t.GANotification ? 'preview__wrapper__title large shadow-box' : 'preview__wrapper__title disabled'}>{t.GANotification ?? commonMessages.empty}</p>
              <p className='preview__wrapper__title'>{t.Channel ? t.Channel.Name : commonMessages.empty}</p>
            </div>
          </div>
        ))}
      </div>
      <div className='create__wrapper_btn'>
        <CustomButtons
          handleClick={() => handleBackPage('Cancel')}
          name='Cancel'
        />
        <CustomButtons
          handleClick={handleBackPage}
          name='Back'
        />
        <CustomButtons
          handleClick={handleSubmit}
          name='Save'
          disabled={loading}
          loadingButton={loading}
        />
      </div>
    </>
  );
};

Preview.propTypes = {
  dimensionPreview: PropTypes.array.isRequired,
  taggingPreview: PropTypes.array.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  ruleType: PropTypes.bool.isRequired,
  alertType: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  customPreview: PropTypes.array
};

Preview.defaultProps = {
  loading: false,
  customPreview: []
};

export default Preview;
